import { gql } from '@apollo/client';
import { PEOPLE_PROFILE } from '../fragments';

export const ALL_ASSIGNED_INSTITUTIONS_PEOPLE = gql`
  query AllAssignedInstitutionsPeople($input: StakeholderFilter) {
    people: allAssignedInstitutionsPeople(input: $input) {
      aggregate {
        count
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          ...peopleProfile
        }
        cursor
      }
    }
  }
  ${PEOPLE_PROFILE}
`;
